import styled from "styled-components";

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;

  .tooltip-text {
    display: none;
    filter: opacity(0);
    background-color: black;
    color: #ffffff;
    text-align: center;
    padding: 4px 8px;
    border-radius: 8px;
    font-size: 13px;
    min-width: 100px;
    right: calc(100% + 4px);
    top: 50%;

    transform: translateY(-50%);
    /* Position the tooltip text - see examples below! */
    position: absolute;
    z-index: 1111111111;
    transition: filter 0.15s ease-in;
  }

  &:hover .tooltip-text {
    display: inline-block;
    filter: opacity(1);
  }
`;

const Tooltip = ({ children, text }) => {
  if (!text) {
    return children;
  }

  return (
    <TooltipWrapper>
      {children}
      <span className="tooltip-text">{text}</span>
    </TooltipWrapper>
  );
};

export default Tooltip;
